import { render, staticRenderFns } from "./CalendarEventSettingsDialog.vue?vue&type=template&id=33a40dda&scoped=true&lang=pug&"
import script from "./CalendarEventSettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventSettingsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventSettingsDialog.vue?vue&type=style&index=0&id=33a40dda&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a40dda",
  null
  
)

export default component.exports